import axios from '@axios'


export async function actualizarPermisos() {
  try {

    const userData = JSON.parse(localStorage.getItem('userData') || 'null')
    if (!userData || !userData.nombre) {
      //console.warn('No hay usuario logueado, no se comprobarán permisos.')
      return false
    }
    const response = await axios.get('/usuarios/permisos')

    // Si no hay datos válidos, salimos
    if (!response?.data?.length) return false

    const nuevosPermisos = response.data[0].permisos || {}
    const permisosActuales = JSON.parse(localStorage.getItem('permisos') || '{}')

    const nuevosStr = JSON.stringify(nuevosPermisos)
    const actualesStr = JSON.stringify(permisosActuales)

    if (nuevosStr !== actualesStr) {
      localStorage.setItem('permisos', nuevosStr)

      setTimeout(() => {
        window.location.reload()
      }, 400)

      return true
    }

    return false
  } catch (error) {
    console.error('Error al actualizar permisos:', error)
    return false
  }
}
